module.exports = __webpack_public_path__ + "img/37.96e4cee2.webp";